var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:arrow-selector-tool"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.18333 14.6666L6.76667 9.46665L4 13.3333V1.33331L13.3333 8.66665H8.6L11 13.8166L9.18333 14.6666Z",
    fill: "#626262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect2);
export default __webpack_public_path__ + "static/media/select2.ba3d04ba2624b5058bae27d495b9ba57.svg";
export { ForwardRef as ReactComponent };